import React from 'react';
import { Box, Typography, Grid, Tooltip, makeStyles } from "@material-ui/core";
import { formatarData, formatarHora } from "../../../shared/utils/Formatacao";
import { TEXT_SUCCESS_COLOR, YELLOW, RED } from '../../../theme';
import { statusAmostra } from '../../../shared/utils/Enum';

const CardAmostrasNoLote = React.memo(({ amostra }) => {
    const classes = useStyles();
    const exames = amostra.exames;

    const tratarCirculoStatus = (status) => {
        switch (status) {
            case statusAmostra.recebido:
                return <span style={{ color: TEXT_SUCCESS_COLOR }}> • </span>;
            case statusAmostra.naoRecebido:
                return <span style={{ color: YELLOW }}> • </span>;
            case statusAmostra.excluida:
                return <span style={{ color: RED }}> • </span>;
            default:
                return null;
        }
    };

    return (
        <Box display="flex" alignItems="left" className={`${classes.larguraCard} borda-padrao`}>
            <Box className={`${classes.espacamentoCard} largura-maxima`}>
                <Grid container>
                    <Grid item xs={8}>
                        <Typography variant="body2" className={classes.espacamentoTextoCard}>
                            <span className="bold">Amostra {amostra.codigo}</span>
                        </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.statusAmostra}>
                        <Typography variant="body2" className={"mr-3"}>
                            <span className={classes.textoStatus}>
                                {tratarCirculoStatus(amostra.status)}
                                {amostra.status}
                            </span>
                        </Typography>
                    </Grid>
                </Grid>
                <Tooltip title={amostra.nomePaciente} placement={'middle'}>
                    <Typography variant="body2" className={classes.espacamentoTextoCard}>
                        <Grid container xs={12} >
                            <Grid item>
                                <span className="bold">Paciente:</span>
                            </Grid>
                            <Grid item className={classes.tamanhoTextoEllipsis}>
                                <Typography noWrap className={classes.textoEllipsis}>{amostra.nomePaciente}</Typography>
                            </Grid>
                        </Grid>
                    </Typography>
                </Tooltip>
                <Typography variant="body2" className={classes.espacamentoTextoCard}>
                    <span className="bold">Data coleta: </span> {formatarData(amostra.dataCadastro)} às {formatarHora(amostra.dataCadastro)}
                </Typography>
                <Typography variant="body2" className={classes.espacamentoTextoCard}>
                    <span className="bold">Data recebimento: </span> {amostra.dataRecebimento ? `${formatarData(amostra.dataRecebimento)} às ${formatarHora(amostra.dataRecebimento)}` : '-'}
                </Typography>
                {exames && exames.length > 0 ?
                    <Tooltip title={exames} placement={'middle'}>
                        <Typography variant="body2" className={classes.espacamentoTextoCard}>
                            <Grid container>
                                <Grid item>
                                    <span className="bold">Exames:</span>
                                </Grid>
                                <Grid item className={classes.tamanhoTextoEllipsis}>
                                    <Typography noWrap className={classes.textoEllipsis}>{exames}</Typography>
                                </Grid>
                            </Grid>
                        </Typography>
                    </Tooltip>
                    :
                    <Typography variant="body2" className={classes.espacamentoTextoCard}>
                        <span className={"largura-maxima"} >Não há exames para essa amostra</span>
                    </Typography>
                }
                <Typography variant="body2" className={classes.espacamentoTextoCard}>
                    <span className="bold">Unid. produtiva: </span> {amostra.unidadeProdutiva ?? "-"}
                </Typography>
            </Box>
        </Box>
    );
});

const useStyles = makeStyles({
    textoEllipsis: {
        fontSize: '14px',
        marginLeft: '4px'
    },
    textoStatus: {
        whiteSpace: 'nowrap',
    },
    larguraCard: {
        width: 'calc (100% - 7px)'
    },
    espacamentoCard: {
        height: "138px",
        padding: '10px 0'
    },
    espacamentoTextoCard: {
        padding: '0 10px'
    },
    statusAmostra: {
        display: 'flex',
        justifyContent: 'end'
    },
    tamanhoTextoEllipsis: {
        width: '170px'
    }
});

export default CardAmostrasNoLote;